export const TREASURE_HUNT_GAME_TYPE = 'andamanda-game-1'
